import React from 'react';
import { RegularButton, IconButton, useMediaQuery, Icon } from 'fronton-react';
import { BookmarkSimpleIcon } from '@fronton/icons-react';
import { Snackbar } from 'pages/common/components/Snackbar';

type TProps = {
  isProjectSaved: boolean;
  saveProjectToShoppingList: () => Promise<void>;
  removeProjectFromShoppingList: () => Promise<void>;
};

export const AddToShoppingList = ({
  isProjectSaved,
  saveProjectToShoppingList,
  removeProjectFromShoppingList,
}: TProps) => {
  const isMobile = useMediaQuery({
    maxWidth: 767,
  });

  const handleToggleProjectStatus = () =>
    isProjectSaved ? removeProjectFromShoppingList() : saveProjectToShoppingList();

  const getIconByProjectStatus = (isSaved: boolean) =>
    isSaved ? (
      // BookmarkSimpleIcon по какой-то причине не хочет принимать другой цвет , выкрутился так
      <Icon color="control-hover-accent">
        <BookmarkSimpleIcon type="fill" size="m" />
      </Icon>
    ) : (
      <BookmarkSimpleIcon type="outline" size="m" color="text-primary" />
    );

  return (
    <>
      {isMobile ? (
        <IconButton
          variant="primary"
          size="l"
          label="Добавить в список покупок"
          onClick={handleToggleProjectStatus}
          data-testid="save-project-button">
          {getIconByProjectStatus(isProjectSaved)}
        </IconButton>
      ) : (
        <RegularButton
          iconLeft={getIconByProjectStatus(isProjectSaved)}
          rounded
          size="m"
          variant="secondary"
          onClick={handleToggleProjectStatus}
          data-testid="save-project-button">
          Добавить в список покупок
        </RegularButton>
      )}
      <Snackbar verticalPosition={isMobile ? 'bottom' : 'top'} />
    </>
  );
};
